<script setup lang="ts">
import { Switch as VarSwitch, type SwitchProps } from '@varlet/ui';

const value = defineModel<boolean>({ required: true });

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { 'onUpdate:modelValue': onUpdateModelValue, ...props } = defineProps<SwitchProps>();
</script>

<template>
  <VarSwitch
    v-bind="props"
    v-model="value"
  />
</template>
